module.exports = __webpack_public_path__ + "img/MANITOU-TABLETTE.cd1f6b2c.png";